import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
export const GoogleDrive = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsxs("svg", {
        ref: ref,
        ...props,
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "#2684fc",
                d: "M8 26.573l4-6.667h16l-4 6.667H8z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#ffba00",
                d: "M20 19.906h8L20 6.573h-8l8 13.333z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#00ac47",
                d: "M4 19.906l4 6.667 8-13.333-4-6.667-8 13.333z"
            })
        ]
    }));
GoogleDrive.displayName = "GoogleDrive";
